import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  labelRoot: {
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: 1.39,
    color: custom.grey[3],
    letterSpacing: 'normal',
    marginBottom: 15,
    '&$labelFocused': {
      color: custom.grey[3],
    },
  },
  labelFocused: {},
  radioIconRoot: {
    color: custom.grey[3],
  },
  radioLabel: {
    fontFamily: 'Lato',
    fontSize: 16,
    lineHeight: 1.38,
    letterSpacing: 'normal',
    color: custom.grey[3],
  },
}));
